export const status = {
  active: 'Active',
  inactive: 'Inactive',
  invited: 'Invited',
  complete: 'Complete',
  approved: 'Approved',
  incomplete: 'Incomplete',
  reject: 'Rejected',
  historical: 'Historical',
};

export const TCMContactStatus = {
  successful: 'Successful',
  unsuccessful: 'Unsuccessful',
};

export const Medication_Log_Status = {
  pending: 'pending',
  validationReportNotFound: 'validationReportNotFound',
  validationError: 'validationError',
  combinedResponseNotFound: 'combinedResponseNotFound',
  dataNotFound: 'dataNotFound',
  MedicationResponseNotFound: 'medicationResponseNotFound',
  successful: 'successful',
  partialSuccess: 'partialSuccess',
};
